import { useContext } from 'react';
import { LoadingContext } from '../../providers';

export const useLoadingContext = () => {
  return useContext(LoadingContext);
};
